<template>
  <div class="onb-master-view">
    <ModuleHeader id="onb-header-1">
      <h2 id="onboarding-module-heading">Průvodce</h2>

      <div class="onb-header-lr">
        <div class="toggle-menu">
          <v-tabs
              v-model="activeTab"
              color="light-green"
              stacked
          >
            <v-tab value="locations" @click="setQuery('locations')">
              <v-icon icon="room"/>
              Lokace
            </v-tab>
            <v-tab value="scenarios" @click="setQuery('scenarios')">
              <v-icon icon="map"/>
              Prohlídky
            </v-tab>
          </v-tabs>
        </div>

        <PrimaryButton id="add-location" v-if="activeTab === 'locations'" @click="goToDetail('location', 'new')">
          Nová lokace
        </PrimaryButton>
        <PrimaryButton id="add-scenario" v-else @click="goToDetail('scenario', 'new')">
          Nová prohlídka
        </PrimaryButton>
      </div>
    </ModuleHeader>

    <v-window v-model="activeTab" :touchless="true">
      <v-window-item value="locations">
        <Locations></Locations>
      </v-window-item>
      <v-window-item value="scenarios">
        <Scenarios></Scenarios>
      </v-window-item>
    </v-window>
  </div>
</template>

<script>
	import PrimaryButton from "../../components/buttons/PrimaryButton";
	import Locations from "@/views/Onboarding/Locations/Locations";
	import Scenarios from "@/views/Onboarding/Scenarios/Scenarios";
	import ModuleHeader from "@/components/layout/ModuleHeader";

	export default {
		name: "OnboardingMaster",

		components: {
			PrimaryButton,
			Locations,
			Scenarios,
			ModuleHeader
		},

    data(){
      return {
        activeTab: 'locations',
      }
    },
    beforeMount() {
      if(this.$route.query?.tab === 'scenarios'){
        this.activeTab = 'scenarios'
      }
    },

    methods: {
			goToDetail(category, id) {
				if (category === 'location') {
					this.$router.push({name: 'locationDetail', params:{id: id}})
				}
				else {
					this.$router.push({name: 'scenarioDetail', params:{id: id}})
				}
			},
      setQuery(category){
        this.$router.replace({query: {tab: category}})
      }
		}
	}
</script>

<style scoped>
	.onb-master-view {
		width: 100%;
	}
	#onb-header-1 {
		display: flex;
		flex-direction: column;
		align-items: baseline!important;
	}
	.onb-header {
		margin-bottom: 1em;
		padding-bottom: 0.3em;
		border-bottom: 2px solid #C4C4C4;
		width: 100%;
	}
	.onb-header-lr {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		width: 100%;
	}
	.toggle-menu {
		width: 400px;
	}
</style>